<ng-container *transloco="let t">
  <article
    class="cheapest-seller-card popsy-card"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.mobileL]="(biggerThan$ | async)?.mobileL"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <!-- badges -->
    @if (showFlags && (biggerThan$ | async)?.xs) {
      <div class="badges-cont">
        @if (bestSeller) {
          <div
            [class.rtl]="isRtl$ | async"
            class="flex align-center justify-center badge">
            {{ t('label_best_seller') }}
          </div>
        }
        <span class="dynamic-space" aria-hidden="true"></span>
        @if (hasDiscount) {
          <app-featured-discount-badge
            [price]="product?.price?.amount"
            [originalPrice]="product?.originalPrice?.amount"
            [flagMode]="false"
            [redColor]="false"></app-featured-discount-badge>
        }
      </div>
    }

    <a
      class="phone-link"
      [routerLink]="linkToCheckout ? ['checkout'] : (urlFragment$ | async)"
      [queryParams]="
        linkToCheckout ? (newCheckoutParamsToKeep$ | async) : (queryParamsToKeep$ | async)
      "
      [attr.aria-label]="product?.model || t('title_activity_listing_settings')">
      @if (bestSeller) {
        <span class="fixed-space-16" aria-hidden="true"></span>
      }
      <span
        class="pic-wrapper flex"
        [class.best-seller]="bestSeller"
        [class.wide-wrapper]="smallerThumb">
        @if (!product) {
          <popsy-skeleton class="picture skeleton"></popsy-skeleton>
        }
        @if (product && !isBrowser) {
          <img
            class="picture"
            [src]="product?.image"
            [alt]="product?.model"
            [title]="product?.model" />
        }
        @if (product && isBrowser) {
          <app-picture
            class="picture"
            [alt]="product?.model"
            [pictureUrl]="product?.image"></app-picture>
        }
      </span>
      <span class="fixed-space-8" aria-hidden="true"></span>
    </a>
    <span class="fixed-space-8" aria-hidden="true"></span>
    <nav class="elem-wrapper text-gray-05 full-height full-width">
      <app-product-reviews-stats [model]="product?.model" />
      <a
        class="phone-link"
        [routerLink]="linkToCheckout ? ['checkout'] : (urlFragment$ | async)"
        [queryParams]="
          linkToCheckout
            ? (newCheckoutParamsToKeep$ | async)
            : (queryParamsToKeep$ | async)
        "
        [attr.aria-label]="product?.model || t('title_activity_listing_settings')">
        <span class="elem-wrapper text-gray-05 full-width">
          <div class="flex flex-mobile justify-between align-base">
            @if (!product) {
              <popsy-skeleton class="title skeleton"></popsy-skeleton>
            }
            @if (product) {
              <h4 [class.wide-title]="product?.category === 'LAPTOP'">
                {{ product?.model || '' }}
              </h4>
            }
          </div>
        </span>
      </a>

      <!--   <span class="fixed-space-16" aria-hidden="true"></span>

      <span class="dynamic-space" aria-hidden="true"></span> -->

      <!-- Price -->
      <span>
        {{ t('price_banner_from') }}
        <b class="text-secondary">{{ product?.price | amount }}</b>
        <span
          class="nowrap"
          [innerHTML]="
            t('price_banner_secondary_or', { var1: product?.price | installmentAmount })
          "></span>
      </span>
    </nav>
  </article>
</ng-container>
